import { render, staticRenderFns } from "./ClientSalesValueReportPrint.vue?vue&type=template&id=2c97ee9a&"
import script from "./ClientSalesValueReportPrint.vue?vue&type=script&lang=js&"
export * from "./ClientSalesValueReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports